import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { getDecodeId } from "slices/userProfile/thunk";
import { CallAPIGetPromise } from "Common/commaon";

interface Homeowner {
  id: string;
  user_first_name: string;
  user_email: string;
}

interface Props {
  show: boolean;
  onClose: () => void;
  onSelect: (homeowner: Homeowner) => void;
}

const SubContractorSelection: React.FC<Props> = ({ show, onClose, onSelect }) => {
  const [homeownerSearch, setHomeownerSearch] = useState<string>("");
  const [subContractorsResult, setSubContractoresResult] = useState<Homeowner[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
 const userId = getDecodeId()
  useEffect(() => {
   SearchSubContractors()
  }, [show]);

  const SearchSubContractors = async () => {
    setLoading(true);
   CallAPIGetPromise(`/subcontractor/get-subcontractores/${userId}`).then((res:any)=>{
    if(res.result){
  setSubContractoresResult(res.result)
    }
   }).finally(()=>{
    setLoading(false)
   })
  };

  return (
    <Modal show={show} onHide={onClose} centered className="tailwind-prefix">
      <div className="bg-white rounded-lg p-4 shadow-lg min-w-[350px] min-h-[500px]">
        <div className="flex justify-between items-center mb-4">
          <h5 className="text-lg font-semibold text-gray-800">Search Sub Contractor</h5>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl">&times;</button>
        </div>

        <input
          type="text"
          value={homeownerSearch}
          onChange={(e) => setHomeownerSearch(e.target.value)}
          placeholder="Enter name or email"
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />

        <div className="mt-4 space-y-2 max-h-64 overflow-auto">
          {loading && <p className="text-sm text-blue-500">Searching...</p>}
          {!loading && homeownerSearch.length > 2 && subContractorsResult.length === 0 && (
            <p className="text-sm text-gray-500">No results found.</p>
          )}
          {subContractorsResult.filter((h) =>{
if(homeownerSearch){
return h.user_email.includes(homeownerSearch)|| h.user_first_name.includes(homeownerSearch)
}else{
  return true
}
          }
          
          ).map((h)=>{
            return  (
              <div
                key={h.id}
                onClick={() => {
                  onSelect(h);
                  onClose();
                }}
                className="p-3 border rounded-md cursor-pointer hover:bg-blue-50 transition-all"
              >
                <div className="font-medium text-gray-800">{h.user_first_name}</div>
                <div className="text-sm text-gray-500">{h.user_email}</div>
              </div>
            )
          })}
        </div>
      </div>
    </Modal>
  );
};

export default SubContractorSelection;
